var map = {
	"./symbol_0.png": "d492",
	"./symbol_1.png": "4903",
	"./symbol_2.png": "e4e7",
	"./symbol_3.png": "8e3f",
	"./symbol_4.png": "815b",
	"./symbol_5.png": "ad46",
	"./symbol_6.png": "664e",
	"./symbol_7.png": "ebbf",
	"./symbol_8.png": "8fd1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b1ed";